module.exports = require('./bundle-url').getBundleURL() + require('./relative-path')("3YTAH", "c9eNS")